module.exports = __webpack_public_path__ + "static/media/cake.7b387530.png";